import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3879a7f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "floating-menu-container" }
const _hoisted_2 = { class: "floating-menu-items" }

import { computed, shallowRef, watch } from 'vue'
import { getVisibleMenuItems, MenuLeaf } from '@sennder/shell-utilities'

import AppLayoutSidebarEntry from './AppLayoutSidebarEntry.vue'
import AppLayoutFloatingMenuFAQEntryVue from './AppLayoutFloatingMenuFAQEntry.vue'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { getStateData } from '@/store/getters'
import { getStoreLegacyFlags } from '@/store/getters'
import { getAppSidebarState } from '@/layouts/AppLayoutSidebarMenu/AppSidebarIconState'
import { analytics } from '@/services/analyticsProvider'
import { useFaqUrl } from '@/components/sennderUrlHelper'
import { AppNavigation, navigation } from '@/config/navigation'
import { AppRoute, routes } from '@/config/routes'
import { mapLegacyIcon } from './legacy-icon'

interface IMenuItemLink {
  icon: string
  translationKey: string
  route?: AppRoute
  externalLink?: string
  analyticsEvent: string
  isNewFeature?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutFloatingMenu',
  emits: ['toggle-menu'],
  setup(__props, { emit: emits }) {



const onClickItem = (analyticsEvent: string) => {
  analytics.trackEvent(
    ANALYTICS_EVENTS[analyticsEvent as keyof typeof ANALYTICS_EVENTS]
  )
  closeMenu()
}

const closeMenu = () => {
  emits('toggle-menu')
}

const navigationItems = shallowRef<AppNavigation[]>([])

watch(
  [() => getStateData(), getStoreLegacyFlags],
  () => {
    navigationItems.value = getVisibleMenuItems(navigation)
  },
  {
    deep: true,
    immediate: true,
  }
)

const appSidebarState = getAppSidebarState()

const faqUrl = useFaqUrl()

const floatingMenuItems = computed<IMenuItemLink[]>(() => {
  const commonItems = navigationItems.value.map((item) => {
    // TODO: types will fix after migration to new sidebar
    const leaf = item as MenuLeaf<AppRoute>
    const route = routes[leaf.route]
    return {
      icon: mapLegacyIcon(leaf.route),
      route: leaf.route,
      translationKey: item.translationKey,
      // TODO: extend Navigation<> to include isNewFeature
      isNewFeature:
        (leaf.route === '/sennfuel' || leaf.route === '/marketplace/tenders') &&
        appSidebarState[route.name] &&
        appSidebarState[route.name] === 'unvisited',
      // TODO: extend Navigation<> to include analyticsEvent
      analyticsEvent: `MENU_${route.name.toUpperCase()}_CLICK`,
    }
  })
  return [
    ...commonItems,
    {
      translationKey: 'sidebar.faq',
      icon: 'faq-icon.svg',
      externalLink: faqUrl.value,
      analyticsEvent: 'MENU_FAQ_CLICK',
    },
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "floating-menu-close-button",
      onClick: closeMenu
    }, " × "),
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(floatingMenuItems.value, (item, idx) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (!!item.route)
            ? (_openBlock(), _createBlock(AppLayoutSidebarEntry, {
                key: `item-${idx}`,
                class: "floating-menu-item",
                route: item.route,
                "translation-key": item.translationKey,
                "is-new": item.isNewFeature,
                icon: item.icon,
                onClick: ($event: any) => (onClickItem(item.analyticsEvent))
              }, null, 8 /* PROPS */, ["route", "translation-key", "is-new", "icon", "onClick"]))
            : (_openBlock(), _createBlock(AppLayoutFloatingMenuFAQEntryVue, {
                key: `item-faq-${idx}`,
                class: "floating-menu-item",
                "translation-key": item.translationKey,
                "external-link": item.externalLink!
              }, null, 8 /* PROPS */, ["translation-key", "external-link"]))
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}
}

})